<template lang="pug">
  figure
    .wrap
      img(:src="src", alt="")
    figcaption
      h6 {{caption}}
</template>
<script>
export default {
  props: {
    src: String,
    caption: String
  }
}
</script>
<style lang="scss" scoped>
  figure{
    margin: 0 1rem;
    .wrap{
      background-color: lighten(black, 20%);
    }
    img{
      display: block;
    }
  }
  figcaption{
    h6{
      font-size: 14px;
      line-height: 18px;
      display: inline;
      color: black;
      font-family: 'Open Sans', Helvetica,Arial,sans-serif;
      margin-right: 8px;
      &::before{
        content: "▲";
        display: inline-block;
        margin-right: 4px;
      }
    }
  }
</style>


